document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }
  document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });
  if (overlay) overlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-cart-drawer-content]');
        var current = drawer.querySelector('[data-cart-drawer-content]');
        if (newContent && current) current.innerHTML = newContent.innerHTML;
        updateCartCount();
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* Intercept product forms to add via AJAX and open drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form], form.product-form-ajax');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.original = submitBtn.textContent; submitBtn.textContent = 'Agregando...'; }

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCart();
      })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.original; }
      });
  });

  updateCartCount();

  /* ---------- Sticky add to cart ----------
     Always visible on the product page, so there's an "add to cart" option
     no matter how far the shopper has scrolled. */
  var stickyAtcButton = document.querySelector('[data-sticky-atc-button]');
  var mainAtc = document.querySelector('[data-main-atc]');
  if (stickyAtcButton && mainAtc) {
    stickyAtcButton.addEventListener('click', function () { mainAtc.click(); });
  }

  /* ---------- Quantity break selector (Buy 1 / 2 / 3) ---------- */
  var qtyBreaks = document.querySelector('[data-quantity-breaks]');
  var qtyInput = document.querySelector('[data-quantity-input]');
  if (qtyBreaks && qtyInput) {
    qtyBreaks.querySelectorAll('[data-qty-break-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        qtyBreaks.querySelectorAll('[data-qty-break-option]').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        qtyInput.value = opt.dataset.qty || 1;
        qtyInput.dispatchEvent(new Event('change'));
      });
    });
  }

  /* ---------- Quantity selectors ----------
     Delegated on document (not bound per-element at load) so this also
     works for markup injected later, like the cart drawer's items after
     refreshCartDrawer() swaps in new HTML. */
  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-qty-minus]');
    var plusBtn = e.target.closest('[data-qty-plus]');
    var btn = minusBtn || plusBtn;
    if (!btn) return;
    var wrap = btn.closest('[data-quantity-selector]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-quantity-input], input[type="number"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var current = parseInt(input.value || String(min), 10);
    input.value = minusBtn ? Math.max(min, current - 1) : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart line quantity / remove ----------
     Drawer lines (have data-cart-line-key) update live via the AJAX Cart
     API. Full cart page lines (main-cart.liquid) use the existing native
     form + "Actualizar carrito" instead, so "Quitar" there just zeroes
     the input and submits that form. */
  function cartChangeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { refreshCartDrawer(); }).catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-quantity-input][data-cart-line-key]');
    if (!input) return;
    cartChangeLine(input.dataset.cartLineKey, Math.max(0, parseInt(input.value || '0', 10)));
  });

  document.addEventListener('click', function (e) {
    var drawerRemoveBtn = e.target.closest('[data-cart-line-remove][data-cart-line-key]');
    if (drawerRemoveBtn) {
      cartChangeLine(drawerRemoveBtn.dataset.cartLineKey, 0);
      return;
    }
    var pageRemoveBtn = e.target.closest('[data-cart-line-remove]:not([data-cart-line-key])');
    if (pageRemoveBtn) {
      var line = pageRemoveBtn.closest('.cart-line');
      var input = line && line.querySelector('[data-quantity-input]');
      var form = pageRemoveBtn.closest('form');
      if (input) input.value = 0;
      if (form) form.submit();
    }
  });

  /* ---------- Product gallery (swipeable carousel) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));

    function setActive(index) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.index, 10) === index); });
      dots.forEach(function (d) { d.classList.toggle('is-active', parseInt(d.dataset.index, 10) === index); });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(parseInt(thumb.dataset.index, 10)); });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10)); });
    });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var width = track.clientWidth || 1;
        var index = Math.round(track.scrollLeft / width);
        setActive(Math.max(0, Math.min(index, slides.length - 1)));
      }, 80);
    }, { passive: true });
  });

  /* ---------- Countdown timer (urgency) ----------
     Counts down to a REAL end date/time set by the merchant in theme
     settings (settings.sale_end_date, "YYYY-MM-DD HH:MM" Uruguay time,
     fixed UTC-3). It does not reset per visit/session — if it hits zero,
     it stays at zero until the merchant updates the date. This avoids the
     "fake countdown that resets on refresh" dark pattern. */
  document.querySelectorAll('[data-countdown-wrap]').forEach(function (wrap) {
    var el = wrap.querySelector('[data-countdown]');
    if (!el) return;
    var raw = (wrap.dataset.end || '').trim();
    if (!raw) { wrap.style.display = 'none'; return; }
    var iso = raw.replace(' ', 'T') + ':00-03:00';
    var end = new Date(iso).getTime();
    if (isNaN(end)) { wrap.style.display = 'none'; return; }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        wrap.style.display = 'none';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var parts = [];
      if (d > 0) parts.push(d + 'd');
      parts.push(String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0'));
      el.textContent = parts.join(' ');
      setTimeout(tick, 1000);
    }
    tick();
  });

});
